function r(r,{format:e}){if(!e)return{};return Object.keys(e({})).reduce(((e,t)=>(r?.hasOwnProperty(t)&&(e[t]=r[t]),e)),{})}export{r as extract};
